<template>
  <layout-content-vertical-nav :nav-menu-items="menuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{ 'expanded-search': shallShowFullSearch }"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-icon
            v-if="$vuetify.breakpoint.mdAndDown"
            class="me-3"
            @click="toggleVerticalNavMenuActive"
          >
            {{ icons.mdiMenu }}
          </v-icon>
          <!-- <app-bar-search
            :shall-show-full-search.sync="shallShowFullSearch"
            :data="appBarSearchData"
            :filter="searchFilterFunc"
            :search-query.sync="appBarSearchQuery"
            @update:shallShowFullSearch="
              handleShallShowFullSearchUpdate(isVerticalNavMenuActive, toggleVerticalNavMenuActive)
            "
          ></app-bar-search> -->
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <!-- <div class="d-flex align-center right-row">
          <app-bar-i18n></app-bar-i18n>
          <app-bar-theme-switcher class="mx-4"></app-bar-theme-switcher>
          <app-bar-notification></app-bar-notification>
          <app-bar-user-menu></app-bar-user-menu>
        </div> -->
        <div class="d-flex align-center right-row">
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div v-if="$vuetify.breakpoint.smAndDown && hasRight">
        <!-- <div class="overflow-hidden"> -->
        <div>
          <v-bottom-navigation
            v-model="bottomValue"
            app
            :input-value="bottomActive"
            color="indigo"
          >
            <v-btn :to="targetBooking">
              <span>My Booking</span>

              <v-icon> mdi-calendar-month </v-icon>
            </v-btn>
            <v-btn
              v-if="isStudent"
              :to="targetDiary"
            >
              <span>Diary</span>
              <v-icon>  mdi-clipboard-list-outline </v-icon>
            </v-btn>
            <v-btn :to="{ path: '/Notice' }">
              <span>Notice</span>
              <v-badge
                v-if="unreadCount"
                :content="unreadCount"
                color="error"
              >
                <v-icon>mdi-chat-processing-outline</v-icon>
              </v-badge>
              <v-icon v-else>
                mdi-chat-processing-outline
              </v-icon>
            </v-btn>
            <v-btn :to="targetProfile">
              <span>Profile</span>
              <v-icon>mdi-account-box-outline</v-icon>
            </v-btn>
          </v-bottom-navigation>
        </div>
      </div>
      <div
        v-else
        class="d-flex justify-space-between"
      >
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} I-Total Service Limited.<span
          class="d-none d-md-inline"
        >, All rights Reserved</span></span>
        <!-- <div class="align-center d-none d-md-flex">
          <span>Hand-crafted &amp; Made with</span>
          <v-icon
            color="error"
            class="ms-2"
          >
            {{ icons.mdiHeartOutline }}
          </v-icon>
        </div> -->
      </div>
    </template>

    <template #v-app-content>
      <!-- <app-customizer class="d-none d-md-block"></app-customizer> -->
    </template>
  </layout-content-vertical-nav>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { mdiHeartOutline, mdiMenu, mdiCalendarMonth, mdiClipboard, mdiChatProcessing, mdiAccountBox } from '@mdi/js'
import { getVuetify } from '@core/utils'
import { useStore } from '@/store'
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'

// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import navMenuItems from '@/navigation/vertical'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'
import AppBarUserMenu from '../components/AppBarUserMenu'
import { getUserData, getMenu } from '@/utils/auth'
import { hasRole } from '@/utils/helper'

const unreadCount = ref('')

/// /dont let noticePath empty
const noticePath = ref({ path: '/Notice' })
const targetDiary = ref({ path: '/COACH_Diary_Record' })
const targetProfile = ref({ path: '/COACH_Profile' })
const targetBooking = ref({ path: '/COACH_Booking_Calendar' })
const hasRight = ref(false)

const roleArr = hasRole([1, 2, 3, 4, 7])
if (roleArr.length > 0) {
  hasRight.value = true
}
const isStudent = ref(false)
const studentRoleArr = hasRole([1])
if (studentRoleArr.length > 0) {
  isStudent.value = true
}
roleArr.forEach(role => {
  if (role.sysRoleID === 1) {
    targetProfile.value = { path: '/STUDENT_Profile' }
    targetBooking.value = { path: '/STUDENT_Booking_Calendar' }
    targetDiary.value = { path: '/STUDENT_Diary_Record' }
  }
})

const menuItems = ref([])
onMounted(() => {
  // console.log('store', store)
  const store = useStore()
  let menus = store.getters.sysRoleMenus
  if (!menus) {
    console.log('menus not found in store')
    menus = getMenu()
  }
  menuItems.value = menus
})
const $vuetify = getVuetify()

// Search
const appBarSearchQuery = ref('')
const shallShowFullSearch = ref(false)
const maxItemsInGroup = 5
const totalItemsInGroup = ref({
  pages: 0,
  files: 0,
  contacts: 0,
})

const menuIsMenuHidden = ref(false)

watch(appBarSearchQuery, () => {
  totalItemsInGroup.value = {
    pages: 0,
    files: 0,
    contacts: 0,
  }
})
const searchFilterFunc = (item, queryText, itemText) => {
  if (item.header || item.divider) return true

  const itemGroup = (() => {
    if (item.to !== undefined) return 'pages'
    if (item.size !== undefined) return 'files'
    if (item.email !== undefined) return 'contacts'

    return null
  })()

  const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

  if (isMatched) {
    if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
    else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
    else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
  }

  return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
}

// ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
  if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
    toggleVerticalNavMenuActive()
  }
}
const bottomValue = ref(1)
const bottomActive = ref(true)
const icons = ref({
  mdiMenu,
  mdiHeartOutline,
  mdiCalendarMonth,
})
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
<style>

.v-bottom-navigation .v-btn--is-elevated{
  box-shadow: unset !important;
}
</style>
